import React from 'react';

import { Button, Alert } from "@material-tailwind/react";

import { useAuth } from '../components/navigation/Authentication.jsx';
import { TestableText } from '@components/general/TestableComponents.jsx';
import UnauthenticatedLayout from '../layouts/UnauthenticatedLayout.jsx';
import { APP_ENVIRONMENT } from '../config.js';
import MetriqLogoSVG from "@components/navigation/Logo/MetriqLogoSVG.jsx";

export default function Login() {
    const { signIn, loginError, isAuthenticating } = useAuth(); // loginError is now part of useAuth
   
    const doSignIn = (e) => {
        e.preventDefault();
        signIn(); // signIn is responsible for updating loginError in case of an error
    };

    return (
        <UnauthenticatedLayout>
            <div className="min-h-screen flex flex-col bg-transparent">
                <div className="flex-grow flex items-start justify-center py-6 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-md w-full mt-24 text-center">
                        <MetriqLogoSVG width={250} className="mb-12 m-auto"/>

                        <Button 
                            data-testid="login-button"
                            color="blue" 
                            size="lg" 
                            onClick={doSignIn} 
                            className="w-full"
                            disabled={isAuthenticating}
                        >
                            {isAuthenticating ? "Logging in..." : "Log In"}
                        </Button>

                        {/* Display login error if it exists */}
                        {loginError && <Alert id="errorAlert" color="pink">{loginError}</Alert>}

                        <TestableText dataTestId="login-page-environment" className="mt-4" variant='paragraph'>{`Environment: ${APP_ENVIRONMENT}`}</TestableText>
                    </div>
                </div>

                <footer className="py-4 text-center">
                    Copyright © {new Date().getFullYear()} tiQtoQ Ltd
                </footer>
            </div>
        </UnauthenticatedLayout>
    );
}